import { UserAttributes } from "../types";
import { createGenericFormSlice, SliceState } from "./genericFormSlice";

const formSlice = createGenericFormSlice({
  name: "userAttributesTab",
  initialState: {} as SliceState<Omit<UserAttributes, "canOwnVents">>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const userAttributesTabReducer = formSlice.reducer;
export default userAttributesTabReducer;
